module.exports = __webpack_public_path__ + "static/img/logo16.9ea6a28a.png";